import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const AcademicService = {
  getAllAcademics(obj) {
    return httpClient.post(endPoints.getAllAcademics, obj);
  },
  getAllAcademicsByPagination(obj) {
    return httpClient.post(endPoints.getAllAcademicsByPagination, obj);
  },
  getAcademicsDetail(obj) {
    return httpClient.post(endPoints.getAcademicsDetail, obj);
  },
  addAcademics(obj) {
    return httpClient.post(endPoints.addAcademics, obj);
  },
  updateAcademics(obj) {
    return httpClient.post(endPoints.updateAcademics, obj);
  },
  deleteAcademics(obj) {
    return httpClient.post(endPoints.deleteAcademics, obj);
  },
};

export default AcademicService;



// WEBPACK FOOTER //
// ./src/service/AcademicService.js